import { c as _c } from "react/compiler-runtime";
import { COUNTRIES, hasEmailPlusAddressing, isDobInTheFuture, isDobTooOld, isDobTooYoung, isValidDate, isVaultTemplateRef } from '@onefootprint/core';
import type { CustomRequirementShortTextFormat, Iso3166TwoDigitCountryCode, Locale } from '@onefootprint/request-types';
import { Form } from '@onefootprint/ui';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
const toInt = (v: string | null | undefined): number | undefined => {
  if (!v) return undefined;
  const n = Number(v);
  return Number.isFinite(n) && Number.isInteger(n) ? n : undefined;
};
type ShortTextInputProps = {
  name: string;
  label: string;
  requiredRules: {
    required?: string;
  };
  config: CustomRequirementShortTextFormat;
  locale?: Locale;
  disableSsnValidation?: boolean;
};
export const ShortTextInput = t0 => {
  const $ = _c(118);
  const {
    name,
    label,
    requiredRules,
    config,
    locale,
    disableSsnValidation
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "collectCustomData.pages.customDataForm"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  const placeholder = "placeholder" in config ? config.placeholder : undefined;
  const {
    trigger,
    getValues,
    clearErrors,
    formState
  } = useFormContext();
  let t2;
  if ($[1] !== clearErrors || $[2] !== formState || $[3] !== getValues || $[4] !== name || $[5] !== trigger) {
    t2 = () => {
      if (getValues(name)) {
        trigger(name);
      } else {
        if (!formState.isSubmitted) {
          clearErrors(name);
        }
      }
    };
    $[1] = clearErrors;
    $[2] = formState;
    $[3] = getValues;
    $[4] = name;
    $[5] = trigger;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const handleFormatBlur = t2;
  if (config.format === "phone_number") {
    let t3;
    if ($[7] !== label || $[8] !== name || $[9] !== requiredRules) {
      t3 = <Form.Tel name={name} label={label} rules={requiredRules} />;
      $[7] = label;
      $[8] = name;
      $[9] = requiredRules;
      $[10] = t3;
    } else {
      t3 = $[10];
    }
    return t3;
  }
  if (config.format === "email") {
    const rejectPlusAddressing = config.disablePlusAddressing;
    let t3;
    if ($[11] !== rejectPlusAddressing || $[12] !== t) {
      t3 = value => {
        if (typeof value !== "string" || value.length === 0) {
          return true;
        }
        if (rejectPlusAddressing && hasEmailPlusAddressing(value)) {
          return t(_temp);
        }
        return true;
      };
      $[11] = rejectPlusAddressing;
      $[12] = t;
      $[13] = t3;
    } else {
      t3 = $[13];
    }
    const validate = t3;
    let t4;
    if ($[14] !== rejectPlusAddressing || $[15] !== requiredRules || $[16] !== validate) {
      t4 = rejectPlusAddressing ? {
        ...requiredRules,
        validate
      } : requiredRules;
      $[14] = rejectPlusAddressing;
      $[15] = requiredRules;
      $[16] = validate;
      $[17] = t4;
    } else {
      t4 = $[17];
    }
    const rules = t4;
    let t5;
    if ($[18] !== placeholder || $[19] !== t) {
      t5 = placeholder || t(_temp2);
      $[18] = placeholder;
      $[19] = t;
      $[20] = t5;
    } else {
      t5 = $[20];
    }
    let t6;
    if ($[21] !== label || $[22] !== name || $[23] !== rules || $[24] !== t5) {
      t6 = <Form.Email name={name} label={label} rules={rules} placeholder={t5} />;
      $[21] = label;
      $[22] = name;
      $[23] = rules;
      $[24] = t5;
      $[25] = t6;
    } else {
      t6 = $[25];
    }
    return t6;
  }
  if (config.format === "ssn9") {
    let t3;
    if ($[26] !== disableSsnValidation || $[27] !== label || $[28] !== name || $[29] !== requiredRules) {
      t3 = <Form.Ssn9 name={name} label={label} rules={requiredRules} useLenientValidation={disableSsnValidation} />;
      $[26] = disableSsnValidation;
      $[27] = label;
      $[28] = name;
      $[29] = requiredRules;
      $[30] = t3;
    } else {
      t3 = $[30];
    }
    return t3;
  }
  if (config.format === "us_tax_id") {
    let t3;
    if ($[31] !== disableSsnValidation || $[32] !== label || $[33] !== name || $[34] !== requiredRules) {
      t3 = <Form.UsTaxId name={name} label={label} rules={requiredRules} useLenientValidation={disableSsnValidation} />;
      $[31] = disableSsnValidation;
      $[32] = label;
      $[33] = name;
      $[34] = requiredRules;
      $[35] = t3;
    } else {
      t3 = $[35];
    }
    return t3;
  }
  if (config.format === "zip") {
    let t3;
    if ($[36] !== placeholder || $[37] !== t) {
      t3 = placeholder || t(_temp3);
      $[36] = placeholder;
      $[37] = t;
      $[38] = t3;
    } else {
      t3 = $[38];
    }
    let t4;
    if ($[39] !== label || $[40] !== name || $[41] !== requiredRules || $[42] !== t3) {
      t4 = <Form.Zip name={name} label={label} rules={requiredRules} country="US" placeholder={t3} />;
      $[39] = label;
      $[40] = name;
      $[41] = requiredRules;
      $[42] = t3;
      $[43] = t4;
    } else {
      t4 = $[43];
    }
    return t4;
  }
  if (config.format === "date") {
    let t3;
    if ($[44] !== label || $[45] !== locale || $[46] !== name || $[47] !== requiredRules) {
      t3 = <Form.Date name={name} label={label} rules={requiredRules} locale={locale} />;
      $[44] = label;
      $[45] = locale;
      $[46] = name;
      $[47] = requiredRules;
      $[48] = t3;
    } else {
      t3 = $[48];
    }
    return t3;
  }
  if (config.format === "vehicle_identification_number") {
    let t3;
    if ($[49] !== placeholder || $[50] !== t) {
      t3 = placeholder || t(_temp4);
      $[49] = placeholder;
      $[50] = t;
      $[51] = t3;
    } else {
      t3 = $[51];
    }
    let t4;
    if ($[52] !== label || $[53] !== name || $[54] !== requiredRules || $[55] !== t3) {
      t4 = <Form.Vin name={name} label={label} rules={requiredRules} placeholder={t3} />;
      $[52] = label;
      $[53] = name;
      $[54] = requiredRules;
      $[55] = t3;
      $[56] = t4;
    } else {
      t4 = $[56];
    }
    return t4;
  }
  if (config.format === "us_state") {
    let t3;
    if ($[57] !== t) {
      t3 = t(_temp5);
      $[57] = t;
      $[58] = t3;
    } else {
      t3 = $[58];
    }
    let t4;
    if ($[59] !== label || $[60] !== name || $[61] !== requiredRules || $[62] !== t3) {
      t4 = <Form.UsState name={name} label={label} rules={requiredRules} placeholder={t3} />;
      $[59] = label;
      $[60] = name;
      $[61] = requiredRules;
      $[62] = t3;
      $[63] = t4;
    } else {
      t4 = $[63];
    }
    return t4;
  }
  if (config.format === "country") {
    const allowed = config.supportedCountries;
    let t3;
    if ($[64] !== allowed) {
      t3 = allowed && allowed.length > 0 ? COUNTRIES.filter(c => allowed.includes(c.value as Iso3166TwoDigitCountryCode)).map(_temp6) : undefined;
      $[64] = allowed;
      $[65] = t3;
    } else {
      t3 = $[65];
    }
    const options = t3;
    let t4;
    if ($[66] !== t) {
      t4 = t(_temp7);
      $[66] = t;
      $[67] = t4;
    } else {
      t4 = $[67];
    }
    let t5;
    if ($[68] !== label || $[69] !== name || $[70] !== options || $[71] !== requiredRules || $[72] !== t4) {
      t5 = <Form.Country name={name} label={label} rules={requiredRules} placeholder={t4} options={options} />;
      $[68] = label;
      $[69] = name;
      $[70] = options;
      $[71] = requiredRules;
      $[72] = t4;
      $[73] = t5;
    } else {
      t5 = $[73];
    }
    return t5;
  }
  if (config.format === "dob") {
    let t3;
    if ($[74] !== config.minAge) {
      t3 = toInt(config.minAge);
      $[74] = config.minAge;
      $[75] = t3;
    } else {
      t3 = $[75];
    }
    const minAge = t3;
    let t4;
    if ($[76] !== config.maxAge) {
      t4 = toInt(config.maxAge);
      $[76] = config.maxAge;
      $[77] = t4;
    } else {
      t4 = $[77];
    }
    const maxAge = t4;
    let t5;
    if ($[78] !== maxAge || $[79] !== minAge || $[80] !== t) {
      t5 = value_0 => {
        if (typeof value_0 !== "string" || value_0.length === 0) {
          return true;
        }
        if (!isValidDate(value_0)) {
          return t(_temp8);
        }
        if (isDobInTheFuture(value_0)) {
          return t(_temp9);
        }
        if (minAge !== undefined && isDobTooYoung(value_0, new Date(), minAge)) {
          return t(_temp10, {
            min: minAge
          });
        }
        if (maxAge !== undefined && isDobTooOld(value_0, new Date(), maxAge)) {
          return t(_temp11, {
            max: maxAge
          });
        }
        return true;
      };
      $[78] = maxAge;
      $[79] = minAge;
      $[80] = t;
      $[81] = t5;
    } else {
      t5 = $[81];
    }
    const validate_0 = t5;
    let t6;
    if ($[82] !== requiredRules || $[83] !== validate_0) {
      t6 = {
        ...requiredRules,
        validate: validate_0
      };
      $[82] = requiredRules;
      $[83] = validate_0;
      $[84] = t6;
    } else {
      t6 = $[84];
    }
    let t7;
    if ($[85] !== handleFormatBlur || $[86] !== label || $[87] !== locale || $[88] !== name || $[89] !== t6) {
      t7 = <Form.Date name={name} label={label} rules={t6} locale={locale} onBlur={handleFormatBlur} />;
      $[85] = handleFormatBlur;
      $[86] = label;
      $[87] = locale;
      $[88] = name;
      $[89] = t6;
      $[90] = t7;
    } else {
      t7 = $[90];
    }
    return t7;
  }
  const regex = config.format === "any" ? config.regex ?? undefined : undefined;
  let t3;
  if ($[91] !== config.format || $[92] !== config.minLength) {
    t3 = config.format === "any" ? toInt(config.minLength) : undefined;
    $[91] = config.format;
    $[92] = config.minLength;
    $[93] = t3;
  } else {
    t3 = $[93];
  }
  const minLength = t3;
  let t4;
  if ($[94] !== config.format || $[95] !== config.maxLength) {
    t4 = config.format === "any" ? toInt(config.maxLength) : undefined;
    $[94] = config.format;
    $[95] = config.maxLength;
    $[96] = t4;
  } else {
    t4 = $[96];
  }
  const maxLength = t4;
  const customRegexError = config.format === "any" ? config.errorMessage ?? undefined : undefined;
  let t5;
  if ($[97] !== regex) {
    t5 = regex && !isVaultTemplateRef(regex) ? new RegExp(`^(?:${regex})$`) : null;
    $[97] = regex;
    $[98] = t5;
  } else {
    t5 = $[98];
  }
  const matcher = t5;
  const hasConstraints = matcher !== null || minLength !== undefined || maxLength !== undefined;
  let t6;
  if ($[99] !== customRegexError || $[100] !== matcher || $[101] !== maxLength || $[102] !== minLength || $[103] !== t) {
    t6 = value_1 => {
      if (typeof value_1 !== "string" || value_1.length === 0) {
        return true;
      }
      if (minLength !== undefined && value_1.length < minLength) {
        return t(_temp12, {
          min: minLength
        });
      }
      if (maxLength !== undefined && value_1.length > maxLength) {
        return t(_temp13, {
          max: maxLength
        });
      }
      if (matcher && !matcher.test(value_1)) {
        return customRegexError || t(_temp14);
      }
      return true;
    };
    $[99] = customRegexError;
    $[100] = matcher;
    $[101] = maxLength;
    $[102] = minLength;
    $[103] = t;
    $[104] = t6;
  } else {
    t6 = $[104];
  }
  const validate_1 = t6;
  let t7;
  if ($[105] !== hasConstraints || $[106] !== requiredRules || $[107] !== validate_1) {
    t7 = hasConstraints ? {
      ...requiredRules,
      validate: validate_1
    } : requiredRules;
    $[105] = hasConstraints;
    $[106] = requiredRules;
    $[107] = validate_1;
    $[108] = t7;
  } else {
    t7 = $[108];
  }
  const rules_0 = t7;
  let t8;
  if ($[109] !== placeholder || $[110] !== t) {
    t8 = placeholder || t(_temp15);
    $[109] = placeholder;
    $[110] = t;
    $[111] = t8;
  } else {
    t8 = $[111];
  }
  const t9 = hasConstraints ? handleFormatBlur : undefined;
  let t10;
  if ($[112] !== label || $[113] !== name || $[114] !== rules_0 || $[115] !== t8 || $[116] !== t9) {
    t10 = <Form.Input name={name} label={label} rules={rules_0} placeholder={t8} onBlur={t9} />;
    $[112] = label;
    $[113] = name;
    $[114] = rules_0;
    $[115] = t8;
    $[116] = t9;
    $[117] = t10;
  } else {
    t10 = $[117];
  }
  return t10;
};
function _temp($) {
  return $.shortText.emailPlusAddressingRejected;
}
function _temp2($_0) {
  return $_0.emailPlaceholder;
}
function _temp3($_1) {
  return $_1.zipPlaceholder;
}
function _temp4($_2) {
  return $_2.vinPlaceholder;
}
function _temp5($_3) {
  return $_3.selectPlaceholder;
}
function _temp6(c_0) {
  return {
    value: c_0.value as Iso3166TwoDigitCountryCode,
    label: c_0.label
  };
}
function _temp7($_4) {
  return $_4.selectPlaceholder;
}
function _temp8($_5) {
  return $_5.shortText.dobInvalid;
}
function _temp9($_6) {
  return $_6.shortText.dobInFuture;
}
function _temp10($_7) {
  return $_7.shortText.ageMin;
}
function _temp11($_8) {
  return $_8.shortText.ageMax;
}
function _temp12($_9) {
  return $_9.shortText.lengthMin;
}
function _temp13($_10) {
  return $_10.shortText.lengthMax;
}
function _temp14($_11) {
  return $_11.shortText.regexMismatch;
}
function _temp15($_12) {
  return $_12.inputPlaceholder;
}